/**
 *
 * React BigCalendar
 * with custom CSS
 */

import styled from 'styled-components';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment/dist/moment';

const localizer = momentLocalizer(moment);
// https://stackoverflow.com/questions/76589100/react-big-calendar-and-dayjs-longer-events-not-showing-in-sundays-or-in-ending-d
localizer.segmentOffset = 0;

export default styled(Calendar).attrs({ localizer })`
  .rbc-day-slot .rbc-event-content {
    line-height: 1.1;
  }
  .rbc-time-view {
    @media screen and (-ms-high-contrast:none) {    // IE11 only
      min-height: 300px;
    }
  }
  // IE11 wants unit at flex
  .rbc-date-cell, .rbc-event-content {
    flex: 1 1 0px;
  }
  .rbc-agenda-view, .rbc-month-view, .rbc-row-bg, .rbc-month-row, .rbc-time-header-content, .rbc-time-slot {
    flex: 1 1 0px;
  }
  @media print {
    .rbc-month-row {
      min-height: 180px;
    }
    .rbc-event-content {
      border: 1px solid ${(p) => p.theme.inputBorder};
    }
    .rbc-time-header-content {
      overflow-x: hidden;
    }
  }

  @media print and (orientation: landscape) {
    .rbc-month-row {
      min-height: 120px;
    }
  }
`;
